import { getRank } from "@/data/ranks";

// Compact title badge reflecting a player's boss-defeat rank.
export function RankBadge({ defeated = 0, size = "sm", className = "" }) {
  const r = getRank(defeated);
  const Icon = r.icon;
  const pad = size === "xs" ? "px-1.5 py-0.5 text-[9px] gap-0.5" : "px-2 py-0.5 text-[10px] gap-1";
  const iconSize = size === "xs" ? "w-2.5 h-2.5" : "w-3 h-3";
  return (
    <span
      data-testid={`rank-badge-${r.key}`}
      className={`inline-flex items-center rounded-full font-bold uppercase tracking-wider ${pad} ${className}`}
      style={{ color: r.color, background: `${r.color}1a`, border: `1px solid ${r.color}55` }}
      title={`Rang : ${r.label} · ${defeated} boss vaincu(s)`}
    >
      <Icon className={iconSize} /> {r.label}
    </span>
  );
}
